import { Component, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { AppContext, SeoService } from './../../shared';
import { BlogPage } from  './../blog-page';

@Component({
  selector: 'five-reasons-to',
  template: require('./five-reasons-to.component.html'),
  styles: [require('./../blog.component.scss'), require('./five-reasons-to.component.scss')]
})
export class FiveReasonsToComponent extends BlogPage {

  title = '5 Reasons to Use Scheduling Data - Linescape';
  description = 'With over 50,000 merchant ships transporting 90% of the world’s trade by sea, how do you plan to navigate around that traffic jam?';

  constructor(route: ActivatedRoute, app: AppContext, seo: SeoService) {
    super(route, app, seo);
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/blog/five-reasons-to/five-reasons-to.component.ts